import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import ErrorField from '~/components/ErrorField';
import { BoxInput, Label } from '../../styles/style';
import { Container } from './style';
import { onlyNumbers } from '~/helpers/generalFunctions';

const DadoFaltantes = ({
  title,
  name,
  formik,
  hasError,
  defaultValue,
  firstReason,
  secondReason,
  onlyNumber = false,
  noPlaceHolder = false,
  ...restProps
}) => {
  const [dadoFaltante, setDadoFaltante] = useState('');
  const [desabilitado, setDesabilitado] = useState(false);
  const [placeholder, setPlaceholder] = useState(title);
  const [mascara, setMascara] = useState('');
  const [isDate] = useState(title.indexOf('Data') > -1);
  const [isHour] = useState(title.indexOf('Hora') > -1);

  useEffect(() => {
    if (isDate) {
      setPlaceholder('__/__/____');
      setMascara('99/99/9999');
    }
    if (isHour) {
      setPlaceholder('__:__');
      setMascara('99:99');
    }
  }, [isDate, isHour]);

  const handleCheck = ({ target }) => {
    const isChecked = target.checked;

    if (isChecked) {
      const fieldValue = defaultValue || mascara;
      formik.setFieldValue(`${name}`, `${fieldValue}`);

      setDadoFaltante(fieldValue);
      setDesabilitado(true);
    } else {
      formik.setFieldValue(`${name}`, '');
      setDadoFaltante('');
      setDesabilitado(false);
    }
  };

  const handleCheckSecond = ({ target }) => {
    const isChecked = target.checked;

    const fieldValue = defaultValue || (isDate ? '98/98/9998' : '98:98');

    if (isChecked) {
      formik.setFieldValue(`${name}`, `${fieldValue}`);

      setDadoFaltante(fieldValue);
      setDesabilitado(true);
    } else {
      formik.setFieldValue(`${name}`, '');
      setDadoFaltante('');
      setDesabilitado(false);
    }
  };

  function createInnerHtml(texto) {
    return { __html: texto };
  }

  return (
    <Container>
      <BoxInput>
        <Label dangerouslySetInnerHTML={createInnerHtml(title)} />

        <Label style={{ display: 'flex' }} className="itemLb">
          {firstReason && (
            <label
              htmlFor={`dadoFaltante-${name}-${firstReason}`}
              className="checkboxException"
            >
              <input
                type="checkbox"
                id={`dadoFaltante-${name}-${firstReason}`}
                name="Dado faltante"
                onClick={handleCheck}
                checked={
                  !!formik.values[name]?.includes('99/99/9999') ||
                  !!formik.values[name]?.includes('99:99') ||
                  formik.values[name] === '0'
                }
              />
              <div className="item-name" style={{ paddingLeft: '5px' }}>
                {firstReason}
              </div>
            </label>
          )}
          {secondReason && (
            <label
              htmlFor={`dadoFaltante-${name}`}
              className="checkboxException"
            >
              <input
                type="checkbox"
                id={`dadoFaltante-${name}`}
                name="Desconhecido por ECG ter sido realizado no pré-hospitalar"
                onClick={handleCheckSecond}
                checked={
                  !!formik.values[name]?.includes('98/98/9998') ||
                  !!formik.values[name]?.includes('98:98') ||
                  formik.values[name] === '0'
                }
              />
              <div className="item-name" style={{ paddingLeft: '5px' }}>
                {secondReason}
              </div>
            </label>
          )}
        </Label>
        {desabilitado ? (
          <InputMask
            type="text"
            disabled={desabilitado}
            placeholder={placeholder}
            value={dadoFaltante}
          />
        ) : (
          <InputMask
            type="text"
            disabled={desabilitado}
            placeholder={!noPlaceHolder ? placeholder : ''}
            value={formik.values[`${name}`] || dadoFaltante}
            name={name}
            onChange={({ target }) => {
              setDadoFaltante(
                onlyNumber ? onlyNumbers(target.value) : target.value
              );
              formik.setFieldValue(
                `${name}`,
                onlyNumber ? onlyNumbers(target.value) : target.value
              );
            }}
            mask={mascara}
            {...restProps}
          />
        )}

        {hasError && <ErrorField message={hasError} />}
      </BoxInput>
    </Container>
  );
};

DadoFaltantes.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hasError: PropTypes.string,
  formik: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  firstReason: PropTypes.string,
  secondReason: PropTypes.string,
};

DadoFaltantes.defaultProps = {
  hasError: '',
  defaultValue: '',
  firstReason: 'Dado faltante',
  secondReason: '',
};

export default DadoFaltantes;
